import React from 'react';
import { termsDataMonths } from '../../enums/termsData'
import replaceCommaWithDot from '../../../../helpers/utils/replaceCommaWithDot';

export default function template(context) {
  const calc = context.calc,
    model = calc.state.model;

  return (
    <React.Fragment>
      <div className="loan-conditions-table">
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_MONTHS')}</div>
          <div className="condition-text">{model.getCreditTerm()}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN')}</div>
          <div className="condition-text">{model.getCreditSum().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_OVERPAYMENT_AEXPRESS_1')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getOverpayment().toLocaleString())} {calc.l10n('UAH_ICON')}</div>
        </div>
      </div>
      <div className="loan-conditions-lines">
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE_NEW_DESIGN_1')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getRealRate())}{calc.l10n('CALCULATOR_CREDIT_PERCENT')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_TOTAL_COST')}</div>
          <div className="condition-text">{replaceCommaWithDot(model.getCreditCost().toLocaleString())} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="disclaimer" dangerouslySetInnerHTML={{__html: calc.l10n('CALCULATOR_DISCLAIMER_02')}}></div>
      </div>
    </React.Fragment>
  );
}